module.exports = "/lucky-balls/img/jackpot/007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/007.png
// module id = 1107
// module chunks = 0